import type { PaymentProcessingInfoPageStore } from '@ctct/state-client-layer';

import type { TranslationGetter } from '../../../types';

export class PaymentProcessingInfoService {
  constructor(private pageStore: PaymentProcessingInfoPageStore, private t: TranslationGetter) {}

  public api() {
    return {
      show: () => this.pageStore.setState({ paymentProcessingInfoVisible: true }),
      hide: () => this.pageStore.setState({ paymentProcessingInfoVisible: false }),
    };
  }

  public data() {
    return {
      getContent: () => {
        return {
          title: this.t('application-layer.payment-processing-info.title'),
          text: this.t('application-layer.payment-processing-info.text'),
        };
      },
    };
  }

  public handlers() {
    return {};
  }
}
